import HeaderNavBar from '../../Components/HeaderNavBar/HeaderNavBar';

const TitlePage = () => {
  return <HeaderNavBar />;
};

export default TitlePage;
